/**
 * Directive: customTypeahead
 */
angular.module('acme.common.directive.customTypeahead', ['ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
.factory('customTypeaheadParser', ['$parse', function($parse) {

  //                      00000111000000000000022200000000000000003333333333333330000000000044000
  var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;

  return {
    parse: function(input) {
      var match = input.match(TYPEAHEAD_REGEXP);
      if (!match) {
        throw new Error(
          'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
          ' but got "' + input + '".');
      }

      return {
        itemName:match[3],
        source:$parse(match[4]),
        viewMapper:$parse(match[2] || match[1]),
        modelMapper:$parse(match[1])
      };
    }
  };
}])

.directive('customTypeahead', ['$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$uibPosition', 'customTypeaheadParser',
  function($compile, $parse, $q, $timeout, $document, $window, $rootScope, $uibPosition, customTypeaheadParser) {
    var HOT_KEYS = [9, 13, 27, 38, 40];
    var eventDebounceTime = 200;

    return {
      require: ['ngModel', '^?ngModelOptions'],
      link: function(originalScope, element, attrs, ctrls) {
        var modelCtrl = ctrls[0];
        var ngModelOptions = ctrls[1];
        //SUPPORTED ATTRIBUTES (OPTIONS)

        //minimal no of characters that needs to be entered before typeahead kicks-in
        var minLength = originalScope.$eval(attrs.customTypeaheadMinLength);
        if (!minLength && minLength !== 0) {
          minLength = 1;
        }

        //minimal wait time after last character typed before typeahead kicks-in
        var waitTime = originalScope.$eval(attrs.customTypeaheadWaitMs) || 0;

        //should it restrict model values to the ones selected from the popup only?
        var isEditable = originalScope.$eval(attrs.customTypeaheadEditable) !== false;

        //binding to a variable that indicates if matches are being retrieved asynchronously
        var isLoadingSetter = $parse(attrs.customTypeaheadLoading).assign || angular.noop;

        //a callback executed when a match is selected
        var onSelectCallback = $parse(attrs.customTypeaheadOnSelect);

        // a callback executed when more results are requested
        var onShowMoreResultsCallback = $parse(attrs.customTypeaheadShowMoreAction);

        // a callback executed when more results are requested
        var onAddNewCallback = $parse(attrs.customTypeaheadAddNewAction);

        //should it select highlighted popup value when losing focus?
        var isSelectOnBlur = angular.isDefined(attrs.customTypeaheadSelectOnBlur) ? originalScope.$eval(attrs.customTypeaheadSelectOnBlur) : false;

        //binding to a variable that indicates if there were no results after the query is completed
        var isNoResultsSetter = $parse(attrs.customTypeaheadNoResults).assign || angular.noop;

        var inputFormatter = attrs.customTypeaheadInputFormatter ? $parse(attrs.customTypeaheadInputFormatter) : undefined;

        var appendToBody =  attrs.customTypeaheadAppendToBody ? originalScope.$eval(attrs.customTypeaheadAppendToBody) : false;

        var focusFirst = originalScope.$eval(attrs.customTypeaheadFocusFirst) !== false;

        //If input matches an item of the list exactly, select it automatically
        var selectOnExact = attrs.customTypeaheadSelectOnExact ? originalScope.$eval(attrs.customTypeaheadSelectOnExact) : false;

        //INTERNAL VARIABLES

        //model setter executed upon match selection
        var parsedModel = $parse(attrs.ngModel);
        var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
        var $setModelValue = function(scope, newValue) {
          if (angular.isFunction(parsedModel(originalScope)) &&
            ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
            return invokeModelSetter(scope, {$$$p: newValue});
          } else {
            return parsedModel.assign(scope, newValue);
          }
        };

        //expressions used by typeahead
        var parserResult = customTypeaheadParser.parse(attrs.customTypeahead);

        var hasFocus;

        //Used to avoid bug in iOS webview where iOS keyboard does not fire
        //mousedown & mouseup events
        //Issue #3699
        var selected;

        //create a child scope for the typeahead directive so we are not polluting original scope
        //with typeahead-specific data (matches, query etc.)
        var scope = originalScope.$new();
        var offDestroy = originalScope.$on('$destroy', function() {
          scope.$destroy();
        });
        scope.$on('$destroy', offDestroy);

        scope.showMoreResults = originalScope.$eval(attrs.customTypeaheadShowMore) || {hasMore: false};
        scope.showAddNew = originalScope.$eval(attrs.customTypeaheadAddNew) || {addNew: false};
        scope.stopEventOnSelect = attrs.customTypeaheadStopEventOnSelect || '';
        scope.dropdownClass = attrs.customTypeaheadDropdownClass || '';

        // WAI-ARIA
        var popupId = 'custom-typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
        element.attr({
          'aria-autocomplete': 'list',
          'aria-expanded': false,
          'aria-owns': popupId
        });

        //pop-up element used to display matches
        var popUpEl = angular.element('<div custom-typeahead-popup></div>');
        popUpEl.attr({
          id: popupId,
          matches: 'matches',
          active: 'activeIdx',
          select: 'select(activeIdx)',
          'select-show-more': 'selectShowMore()',
          'select-add-new': 'selectAddNew()',
          'move-in-progress': 'moveInProgress',
          query: 'query',
          position: 'position',
          'show-more-results': 'showMoreResults',
          'show-add-new': 'showAddNew',
          'stop-event-on-select': scope.stopEventOnSelect,
          'dropdown-class': scope.dropdownClass
        });
        //custom item template
        if (angular.isDefined(attrs.customTypeaheadTemplateUrl)) {
          popUpEl.attr('template-url', attrs.customTypeaheadTemplateUrl);
        }

        if (angular.isDefined(attrs.customTypeaheadPopupTemplateUrl)) {
          popUpEl.attr('popup-template-url', attrs.customTypeaheadPopupTemplateUrl);
        }

        var resetMatches = function() {
          scope.lastActiveIdx = angular.copy(scope.activeIdx);
          scope.matches = [];
          scope.activeIdx = -1;
          element.attr('aria-expanded', false);
        };

        var getMatchId = function(index) {
          return popupId + '-option-' + index;
        };

        // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
        // This attribute is added or removed automatically when the `activeIdx` changes.
        scope.$watch('activeIdx', function(index) {
          if (index < 0) {
            element.removeAttr('aria-activedescendant');
          } else {
            element.attr('aria-activedescendant', getMatchId(index));
          }
        });

        var inputIsExactMatch = function(inputValue, index) {
          if (scope.matches.length > index && inputValue && scope.matches[index]) {
            return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
          }

          return false;
        };

        var findFirstMatchIdx = function(inputValue) {
          var index = -1;

          if (inputValue) {
            for (var i = 0, ii = scope.matches.length; i < ii; i++) {
              if (scope.matches[i].label && scope.matches[i].label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1) {
                index = i;
                break;
              }
            }
          }

          return index;
        };

        var findExactMatchIdx  = function(inputValue) {
          var index = -1;

          for (var i = 0, ii = scope.matches.length; i < ii; i++) {
            if (scope.matches[i].label && inputValue.toUpperCase() === scope.matches[i].label.toUpperCase()) {
              index = i;
              break;
            }
          }

          return index;
        };

        var getMatchesAsync = function(inputValue) {
          var locals = {$viewValue: inputValue};
          isLoadingSetter(originalScope, true);
          isNoResultsSetter(originalScope, false);
          parserResult = customTypeaheadParser.parse(attrs.customTypeahead);
          scope.showMoreResults = originalScope.$eval(attrs.customTypeaheadShowMore) || {hasMore: false};
          scope.showAddNew = originalScope.$eval(attrs.customTypeaheadAddNew) || {addNew: false};
          scope.stopEventOnSelect = attrs.customTypeaheadStopEventOnSelect || '';
          $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
            //it might happen that several async queries were in progress if a user were typing fast
            //but we are interested only in responses that correspond to the current view value
            var onCurrentRequest = (inputValue === modelCtrl.$viewValue);
            if (onCurrentRequest && hasFocus) {
              if (matches && matches.length > 0) {

                scope.activeIdx = focusFirst ? 0 : -1;
                isNoResultsSetter(originalScope, false);
                scope.matches.length = 0;

                //transform labels
                for (var i = 0; i < matches.length; i++) {
                  locals[parserResult.itemName] = matches[i];
                  scope.matches.push({
                    id: getMatchId(i),
                    label: parserResult.viewMapper(scope, locals),
                    model: matches[i]
                  });
                }

                scope.query = inputValue;
                //position pop-up with matches - we need to re-calculate its position each time we are opening a window
                //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
                //due to other elements being rendered
                recalculatePosition();

                element.attr('aria-expanded', true);

                //Select the single remaining option if user input matches
                /*if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
                  scope.select(0);
                }else*/ if (inputIsExactMatch(inputValue, scope.lastActiveIdx)) {
                  scope.$broadcast('CustomTypeahead::SetActive', { activeIdx: scope.lastActiveIdx });
                }else {
                  scope.activeIdx = findFirstMatchIdx(inputValue);
                  if (scope.activeIdx >= 0) {
                    scope.$broadcast('CustomTypeahead::SetActive', { activeIdx: scope.activeIdx });
                  }
                }
              } else {
                resetMatches();
                isNoResultsSetter(originalScope, true);
              }
            }
            if (onCurrentRequest) {
              isLoadingSetter(originalScope, false);
            }
          }, function() {
            resetMatches();
            isLoadingSetter(originalScope, false);
            isNoResultsSetter(originalScope, true);
          });
        };

        // bind events only if appendToBody params exist - performance feature
        if (appendToBody) {
          angular.element($window).bind('resize', fireRecalculating);
          $document.find('body').bind('scroll', fireRecalculating);
        }

        // Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
        var timeoutEventPromise;

        // Default progress type
        scope.moveInProgress = false;

        function fireRecalculating() {
          if (!scope.moveInProgress) {
            scope.moveInProgress = true;
            $timeout(function() {
              // scope.$digest();
            }, 0);
          }

          // Cancel previous timeout
          if (timeoutEventPromise) {
            $timeout.cancel(timeoutEventPromise);
          }

          // Debounced executing recalculate after events fired
          timeoutEventPromise = $timeout(function() {
            // if popup is visible
            if (scope.matches.length) {
              recalculatePosition();
            }

            scope.moveInProgress = false;
            if(!scope.$$phase) {
              scope.$digest();
            }
          }, eventDebounceTime);
        }

        // recalculate actual position and set new values to scope
        // after digest loop is popup in right position
        function recalculatePosition() {
          scope.position = appendToBody ? $uibPosition.offset(element) : $uibPosition.position(element);
          scope.position.top += element.prop('offsetHeight');
        }

        resetMatches();

        //we need to propagate user's query so we can higlight matches
        scope.query = undefined;

        //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
        var timeoutPromise;

        var scheduleSearchWithTimeout = function(inputValue) {
          timeoutPromise = $timeout(function() {
            getMatchesAsync(inputValue);
          }, waitTime);
        };

        var cancelPreviousTimeout = function() {
          if (timeoutPromise) {
            $timeout.cancel(timeoutPromise);
          }
        };

        //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
        //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
        modelCtrl.$parsers.unshift(function(inputValue) {
          hasFocus = true;

          if (minLength === 0 || inputValue && inputValue.length >= minLength) {
            if (waitTime > 0) {
              cancelPreviousTimeout();
              scheduleSearchWithTimeout(inputValue);
            } else {
              getMatchesAsync(inputValue);
            }
          } else {
            isLoadingSetter(originalScope, false);
            cancelPreviousTimeout();
            resetMatches();
          }

          if (isEditable) {
            return inputValue;
          } else {
            if (!inputValue) {
              // Reset in case user had typed something previously.
              modelCtrl.$setValidity('editable', true);
              return null;
            } else {
              modelCtrl.$setValidity('editable', false);
              return undefined;
            }
          }
        });

        modelCtrl.$formatters.push(function(modelValue) {
          var candidateViewValue, emptyViewValue;
          var locals = {};

          // The validity may be set to false via $parsers (see above) if
          // the model is restricted to selected values. If the model
          // is set manually it is considered to be valid.
          if (!isEditable) {
            modelCtrl.$setValidity('editable', true);
          }

          if (inputFormatter) {
            locals.$model = modelValue;
            return inputFormatter(originalScope, locals);
          } else {
            //it might happen that we don't have enough info to properly render input value
            //we need to check for this situation and simply return model value if we can't apply custom formatting
            locals[parserResult.itemName] = modelValue;
            candidateViewValue = parserResult.viewMapper(originalScope, locals);
            locals[parserResult.itemName] = undefined;
            emptyViewValue = parserResult.viewMapper(originalScope, locals);

            return candidateViewValue!== emptyViewValue ? candidateViewValue : modelValue;
          }
        });

        scope.select = function(activeIdx, silent) {
          //called from within the $digest() cycle
          var locals = {};
          var model, item;

          selected = true;
          if (!silent) {
          locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
          model = parserResult.modelMapper(originalScope, locals);
          $setModelValue(originalScope, model);
          modelCtrl.$setValidity('editable', true);
          modelCtrl.$setValidity('parse', true);


            onSelectCallback(originalScope, {
              $item: item,
              $model: model,
              $label: parserResult.viewMapper(originalScope, locals)
            });

            resetMatches();

            //return focus to the input element if a match was selected via a mouse click event
            // use timeout to avoid $rootScope:inprog error
            if (scope.$eval(attrs.customTypeaheadFocusOnSelect) !== false) {
              $timeout(function () {
                element[0].click();
              }, 0, false);
            }
          }
        };

        scope.selectShowMore = function() {
          var item = {field: element[0].id};
          onShowMoreResultsCallback(originalScope, {
            $item: item,
            $model: {},
            $label: {}
          });
        };

        scope.selectAddNew = function() {
          var item = {field: element[0].id};
          onAddNewCallback(originalScope, {
            $item: item,
            $model: {},
            $label: {}
          });
        };

        element.bind('focus', function(evt) {
          hasFocus = true;
          element[0].setSelectionRange(0, element[0].value.length);
          scheduleSearchWithTimeout(evt.target.value || '');
        });

        //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
        element.bind('keydown', function(evt) {
          //typeahead is open and an "interesting" key was pressed
          if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
            return;
          }

          // if there's nothing selected (i.e. focusFirst) and enter or tab is hit, clear the results
          if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13)) {
            resetMatches();
            scope.$digest();
            return;
          }

          evt.preventDefault();

          if (evt.which === 40) {
            scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
            scope.$digest();
            scope.$broadcast('CustomTypeahead::UpdateActive', { activeIdx: scope.activeIdx });
          } else if (evt.which === 38) {
            scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
            scope.$digest();
            scope.$broadcast('CustomTypeahead::UpdateActive', { activeIdx: scope.activeIdx });

          } else if (evt.which === 13 || evt.which === 9) {
            scope.$apply(function () {
              scope.select(scope.activeIdx);
            });

          } else if (evt.which === 27) {
            evt.stopPropagation();

            resetMatches();
            scope.$digest();
            element[0].setSelectionRange(0, element[0].value.length);
          }
        });

        element.bind('blur', function() {
          if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
            selected = true;
            scope.$apply(function() {
              scope.select(scope.activeIdx);
            });
          }
          hasFocus = false;
          selected = false;
        });

        // Keep reference to click handler to unbind it.
        var dismissClickHandler = function(evt) {
          // Issue #3973
          // Firefox treats right click as a click on document
          var isShowMoreTarget = $(evt.target).closest('[data-showMore]').length;
          if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
            if (!isShowMoreTarget) {
              resetMatches();
            }
            if (!$rootScope.$$phase) {
              scope.$digest();
            }
          }
        };

        $document.bind('click', dismissClickHandler);

        originalScope.$on('$destroy', function() {
          $document.unbind('click', dismissClickHandler);
          if (appendToBody) {
            $popup.remove();
          }
          // Prevent jQuery cache memory leak
          popUpEl.remove();
        });

        originalScope.$on('CustomTypeahead::FilterResults', function(e, data) {
          if (data.field === element[0].id) {
            hasFocus = true;
            scheduleSearchWithTimeout(element[0].value || '');
          }
        });

        var $popup = $compile(popUpEl)(scope);

        if (appendToBody) {
          $document.find('body').append($popup);
        } else {
          element.after($popup);
        }
      }
    };

  }])

.directive('customTypeaheadPopup', ['$timeout', function($timeout) {
  return {
    restrict: 'EA',
    scope: {
      matches: '=',
      query: '=',
      active: '=',
      position: '&',
      moveInProgress: '=',
      dropdownClass: '@',
      select: '&',
      selectShowMore: '&',
      showMoreResults: '=',
      stopEventOnSelect: '@',
      selectAddNew: '&',
      showAddNew: '='
    },
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.popupTemplateUrl || 'common/directives/customTypeahead/customTypeaheadPopup.tpl.html';
    },
    link: function(scope, element, attrs) {
      scope.templateUrl = attrs.templateUrl;

      scope.isOpen = function() {
        return scope.matches.length > 0;
      };

      scope.isActive = function(matchIdx) {
        return scope.active == matchIdx;
      };

      scope.selectActive = function(matchIdx) {
        scope.active = matchIdx;
      };

      scope.selectMatch = function(activeIdx, e) {
        scope.select({activeIdx:activeIdx});
        if (scope.stopEventOnSelect) {
          e.stopPropagation();
        }
      };

      scope.showMore = function() {
        scope.selectShowMore();
      };

      scope.addNew = function() {
        scope.selectAddNew();
      };

      scope.updatePosition = function(activeIdx) {

        var list = element.find('li');

        element.stop(true, true);

        if ($(list[activeIdx]).get(0)) {
          element.animate({
            scrollTop: $(list[activeIdx]).position().top += element.scrollTop()
          }, 300);
        }
      };

      scope.$on('CustomTypeahead::UpdateActive', function(e, data) {
        $timeout(function () {
          scope.updatePosition(data.activeIdx);
        }, 10);
      });

      scope.$on('CustomTypeahead::SetActive', function(e, data) {
        $timeout(function() {
          scope.selectActive(data.activeIdx);
          scope.updatePosition(data.activeIdx);
        }, 10);
      });
    }
  };
}])

.directive('customTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
  return {
    restrict: 'EA',
    scope: {
      index: '=',
      match: '=',
      query: '='
    },
    link:function(scope, element, attrs) {
      var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'common/directives/customTypeahead/customTypeaheadMatch.tpl.html';
      $templateRequest(tplUrl).then(function(tplContent) {
        $compile(tplContent.trim())(scope, function(clonedElement) {
          element.replaceWith(clonedElement);
        });
      });
    }
  };
}])

.filter('customTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
  var isSanitizePresent;
  isSanitizePresent = $injector.has('$sanitize');

  function escapeRegexp(queryToEscape) {
    // Regex: capture the whole query string and replace it with the string that will be used to match
    // the results, for example if the capture is "a" the result will be \a
    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
  }

  function containsHtml(matchItem) {
    return (/<.*>/g).test(matchItem);
  }

  return function(matchItem, query) {
    if (!isSanitizePresent && containsHtml(matchItem)) {
      $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
    }
    matchItem = query? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
    if (!isSanitizePresent) {
      matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
    }
    return matchItem;
  };
}]);